<template>
  <div class="form-group">
    <div class="dropdown fares-dropdown" id="faresDropdown">
      <label :class="hidelabel ? 'sr-only' :'' ">{{ $t("passengers") }}</label>
      <button type="button" class="btn btn-form-input dropdown-toggle" data-toggle="dropdown" aria-haspopup="true"
        aria-expanded="false">
        <span class="btn-label" v-if="currentPassengerString">{{
            currentPassengerString
        }}</span>
        <span class="btn-label" v-else>{{ $t("passengers") }}</span>

        <span class="icon-right">
          <i class="fa fa-child"></i>
        </span>
      </button>
      <div id="passenger-inputs" class="dropdown-menu">
        <div class="passenger-item" v-for="fare in fares" :key="fare._id">
          <div class="passenger-item--label">
            <label v-bind:for="fare.indexableName">
              <span>{{ getLexiconTranslation(fare.lexiconKeys.name) }}</span>
              <br />
              {{ getLexiconTranslation(fare.lexiconKeys.description) }}
            </label>
          </div>
          <numberStepper v-bind:id="fare._id" v-bind:name="fare.indexableName" v-model="selectedFares[fare._id]"
            :min="0" :max="13" @change="updateSelectedFares" inline controls></numberStepper>
        </div>
        <button @click.prevent="closeFares" class="btn btn-primary">
          {{ $t("close") }}
        </button>
      </div>
    </div>
    <span class="label label-danger form-error" v-if="errors[0]">
      <strong>
        <span class="prefix">{{ $t("errorPrefix") }}</span>
        <span v-html="errors[0].value"></span>
      </strong>
    </span>
  </div>
</template>

<script>
import { mapState, mapGetters } from "vuex";
import numberStepper from "./numberStepper.vue";

export default {
  props: { errors: Array, hidelabel: Boolean },
  data() {
    return {
      destinationId: "to",
      selectedFares: {},
    };
  },
  components: {
    numberStepper,
  },
  watch: {
    fares: function () {
      // When we change products, fares are updated. Local selectedFares needs to be rebuilt.
      let selectedFares = {};
      this.fares.forEach((fare) => {
        selectedFares[fare._id] = 0;
      });
      this.selectedFares = selectedFares;
    }
  },
  computed: {
    ...mapState(["fares", "selectedFaresStore"]),
    ...mapGetters(["currentPassengerString", "getLexiconTranslation"]),
  },
  methods: {
    closeFares() {
      document.getElementById("faresDropdown").classList.toggle("open");
      document.getElementById("findTrips").focus();
    },
    updateSelectedFares() {
      this.$store.commit("setFares", this.selectedFares);
      //this.$store.commit("SET_SELECTED_FARES", this.selectedFares);
    },
  },
  mounted() {
    // const selectedFares = {};
    // this.fares.forEach((fare) => {
    //   selectedFares[fare._id] = 0;
    // });
    // this.selectedFares = selectedFares;
    if (Object.keys(this.selectedFaresStore).length) {
      this.selectedFares = this.selectedFaresStore;
    }
  },
  created() {
    if (Object.keys(this.selectedFaresStore).length) {
      // If we already have fares in state do nothing.
    } else {
      let selectedFares = {};
      this.fares.forEach((fare) => {
        selectedFares[fare._id] = 0;
      });
      this.selectedFares = selectedFares;
    }
  },
};
// Ensure dropdown stays open on input click.
// eslint-disable-next-line
jQuery(document).on("click", ".fares-dropdown .dropdown-menu", function (e) {
  e.stopPropagation();
});
</script>

<style lang="scss">
.passenger-item label span {
  text-transform: capitalize;
}

.passenger-item--label,
.number-input {
  width: 50%;
  display: inline-block;
}

.fares-dropdown .dropdown-toggle {
  width: 100%;
  text-align: left;
  background-color: #fff;
  border:1px solid #E4E4E4;
  font-weight: 300;
  border-radius: 2px;
  color: #1F2123;
  height:50px;

  .icon-right {
    float: right;
    color: $brand-highlight;
  }

  &:focus {
    border-color: #66afe9;
    outline: 0;
    -webkit-box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075),
      0 0 8px rgba(102, 175, 233, 0.6);
    box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075),
      0 0 8px rgba(102, 175, 233, 0.6);
  }
}

#passenger-inputs {
  border-radius: 0;
  min-width: 240px;
  border-top: 5px solid #febc11;
  padding: 15px;

  .btn-primary {
    margin: 15px auto 0px auto;
    display: block;
  }
}

#mini-widget-app .passenger-item {
  label {
    color: #575756;
    font-weight: normal;

    span {
      color: $brand-primary;
      font-size: 18px;
    }
  }

  .number-input--inline {
    vertical-align: top;
  }

  .number-input__button {
    color: $brand-primary;
    background-color: transparent;
    border: none;
  }

  button[disabled] {
    opacity: 0.5;
  }
}
</style>
